import UserRole from "./userRole";

/**
 * Self Model
 * @param {boolean} isAuthenticated
 * @param {array} Roles
 * @returns {Class} - Self instance
 */
class Self {
	constructor({
		is_authenticated: isAuthenticated ,
		roles
	} = {}) {
		this._isAuthenticated = isAuthenticated;
		this._userRoles = roles ? roles.map(userRole => new UserRole(userRole)) : [];
	}

	getKey() {
		return '';
	}

	isAuthenticated() {
		return this._isAuthenticated;
	}

	getUserRoles() {
		return this._userRoles;
	}

	hasUserRoles() {
		return Boolean(this._userRoles && this._userRoles.length);
	}

	findRole(roles, level, value=null) {
		const sameLevel = this.getUserRoles().filter(userRole => (userRole.getLevel() === level && value !== null ? userRole.getValue() === value : true));
		const hasSlug = sameLevel.filter(userRole =>  roles.indexOf(userRole.getRole().getSlug()) !== -1);

		return Boolean(hasSlug.length);
	}

	isAdmin() {
		return this.findRole('target-admin', 0);
	}

	isCampaignAdmin() {
		return this.isAdmin() && this.hasCapacity("BobyCapacity.CAMPAIGN_ADMIN");
	}

	hasCapacity(capacity, organization = null) {
		const userRoles = this.getUserRoles();
		let hasUserCapacity = Boolean(
			userRoles
				.filter(r => r._context.level === 0)
				.find(r => r.getRole().getCapacities().find(c => c.slug === capacity))
		);
		if (!hasUserCapacity && organization) {
			// if we didn't find the capacity at context level 0 we check at level 1 if the organization is provided
			hasUserCapacity = Boolean(
				userRoles
					.filter(r => r._context.level === 3 && r._context.value === organization.getWeezID().toString())
					.find(r => r.getRole().getCapacities().find(c => c.slug === capacity))
			);
		}
		return hasUserCapacity;
	}
}
export default Self;
